<template>
  <NuxtLink
    :to="to ?? $localePath({ name: 'index' })"
    class="-ml-0.5 overflow-hidden min-w-fit hover:sm:opacity-60 transition-opacity duration-300"
  >
    <ClientOnly>
      <AImg
        format="webp"
        densities="x1 x2"
        :src="logoSrc"
        :width="width || ($device.isMobile ? 180 : 200)"
        alt="Logo QuotaTrip"
      />
      <template #fallback>
        <USkeleton class="h-[28px] mb-2 w-[176px]" />
      </template>
    </ClientOnly>

    <div
      v-if="showBaseline"
      class="flex items-center h-10 -mt-2 ml-0.5 overflow-hidden space-x-0.5"
    >
      <p class="text-black dark:text-white">
        {{ t("components.theLogo.websiteBy") }}
      </p>
      <AImg
        alt="Logo Petit fûté"
        class="mb-[6px]"
        src="/images/petit-fute-logo-vector.svg"
        height="22"
        width="90"
      />
    </div>
  </NuxtLink>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

const props = withDefaults(
  defineProps<{
    forcedColorMode?: 'dark' | 'light'
    logos?: {
      dark: string
      light: string
    }
    showBaseline?: boolean
    to?: RouteLocationRaw
    width?: number | undefined
  }>(),
  {
    alt: 'Logo',
    forcedColorMode: undefined,
    logos: () => ({
      dark: '/images/logo_dark.svg',
      light: '/images/logo_light.svg',
    }),
    showBaseline: true,
    width: 200,
  },
)

const { t } = useI18n()

const colorMode = useColorMode()

const logoSrc = computed(
  () =>
    props.logos?.[
      (props.forcedColorMode || colorMode.value) as keyof typeof props.logos
    ],
)
</script>
